<script>
import { mapActions } from 'vuex'
import AddSenderProductModal from '@/components/Administration/Senders/AddSenderProductModal.vue'
import Headline from '@/components/Helpers/Headline.vue'
import _ from 'lodash'
import ConfirmModal from '@/components/Modals/ConfirmModal.vue'
import { eventBus } from '@/main'

export default {
  name: 'EditSenderProducts',
  components: { ConfirmModal, Headline, AddSenderProductModal },
  data () {
    return {
      show_add_modal: false,
      show_delete_products: false,
      sender_products: [],
      sender: null,
      selected_products: [],
      headers: [
        {
          title: '',
          check_all: true,
          class: 'custom-checkbox'
        },
        {
          title: 'Фото',
          sortable: false,
          class: 'img_prod',
          value: 'id'
        },
        {
          title: 'Название',
          class: 'name_prod_long',
          sortable: false,
          value: 'name'
        },
        {
          title: 'Артикул',
          class: 'code_prod_long',
          sortable: false,
          value: 'vendor_code'
        },
        {
          title: '',
          class: 'ico_wrap'
        }
      ]
    }
  },
  computed: {
    isSelectAll: {
      get: function () {
        if (this.sender_products === null) {
          return false
        }
        return this.selected_products.length === this.sender_products.length && this.selected_products.length > 0
      },
      set: function (value) {
        if (value) {
          this.selected_products = _.map(this.sender_products, 'id')
        } else {
          this.selected_products = []
        }
      }
    }
  },
  methods: {
    ...mapActions('senders', ['getSenderProducts', 'deleteSenderProducts']),
    store () {
    },
    loadData () {
      this.show_add_modal = false
      this.getSenderProducts(this.$route.params.id).then(response => {
        this.sender = response.data.sender
        this.sender_products = response.data.products
      })
    },
    sendDeleteProducts () {
      const data = {
        sender_id: this.$route.params.id,
        product_ids: this.selected_products
      }

      this.deleteSenderProducts(data).then(response => {
        this.loadData()
        eventBus.$root.$emit(
          'send_notify',
          'success',
          response.data.message
        )
        this.show_delete_products = false
        this.selected_products = []
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<template>
  <section class="table_box all_products inner">
    <div class="container flx">
      <div class="table_head">
        <span class="page_title">Товары отправителя</span>
      </div>
      <div class="wrap_btn flx">
        <a @click="$router.go(-1)" class="back flx cursor-pointer">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.97814 0.796948C6.28105 1.09986 6.28105 1.59098 5.97814 1.89389L1.87267 5.99936L5.97814 10.1048C6.28105 10.4077 6.28105 10.8989 5.97814 11.2018C5.67522 11.5047 5.18411 11.5047 4.88119 11.2018L0.227251 6.54783C-0.0756619 6.24492 -0.0756619 5.7538 0.227251 5.45089L4.88119 0.796948C5.18411 0.494035 5.67522 0.494035 5.97814 0.796948Z"
                  fill="#F5A32A"/>
          </svg>
          <span>Назад</span>
        </a>
        <div
            v-if="selected_products.length > 0"
            style="background: #ff5a5a; color: white; margin-right: 10px"
            class="btn"
            @click="show_delete_products = true"
        >Удалить</div>
        <div class="btn" @click="show_add_modal = true">Добавить товар</div>
      </div>
    </div>
    <div class="container">
      <div class="table_body">
        <div class="top_table flx">
          Отправитель: {{ sender ? (sender.first_name + ' ' + sender.last_name) : '-' }}
        </div>
        <div class="bot_table">
          <headline :headers="headers" :selected-all.sync="isSelectAll" ></headline>
          <div class="row_list">
            <div
                class="row flx"
                :class="{ checked: selected_products.indexOf(product.id) !== -1}"
                :key="product.id"
                v-for="product in sender_products"
            >
              <label class="custom-checkbox" @click.stop>
                <input v-model="selected_products" type="checkbox" :value="product.id">
                <span></span>
              </label>
              <div class="img_prod">
                <img v-if="product.cache.image" :src="product.cache.image[60]" alt="product">
                <img v-else src="/images/no-img.svg" alt="product">
              </div>
              <div
                  class="name_prod_long flx"
                  @click="$router.push('/dashboard/dropshipping/products/'+product.id)"
              >
                <span><b>{{ product.name }}</b></span>
              </div>
              <div class="code_prod_long">
                <router-link :to="'/dashboard/dropshipping/products/'+product.id">{{ product.vendor_code }}</router-link>
              </div>
              <div class="size_prod">
                <span>{{ product.cache.size_string }}</span>
              </div>
              <div class="color_prod">
                <span v-for="color in product.cache.colors" :key="color">{{ color }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddSenderProductModal
        v-model="show_add_modal"
        @added="loadData()"
    />
    <ConfirmModal
        v-model="show_delete_products"
        title="Вы действительно хотите удалить выбранные товары?"
        btn_ok="Удалить"
        @confirm="sendDeleteProducts()"
    />
  </section>
</template>

<style scoped>

</style>
